module.exports = __webpack_public_path__ + "img/YouPiece.83a9b7ea.png";